'use client';

import { useTranslations } from 'next-intl';
import { usePathname } from 'next/navigation';
import Image from 'next/image';

import Button from '@/components/ui/Button';
import Icon from '@/components/ui/Icon';

import styles from './Faq.module.scss';

export default function Template({ children }: { children: React.ReactNode }) {
  const t = useTranslations('Faq');
  const pathname = usePathname();
  const isResume = pathname === '/checkout/resume';

  return (
    <main>
      <section className={styles.header}>
        <div className={`container ${styles['header__container']}`}>
          <h1
            className="title title--xlarge title--color-light-50"
            dangerouslySetInnerHTML={{ __html: t.raw('title') }}
          />
          <div className={styles['header__content']}>
            <p className="text text--color-light-50">{t('description')}</p>
            <Button
              href="/faq/send-question"
              color="primary-inverse"
              variant="contained"
              transform="initial"
            >
              {t('cta_not_found')}
            </Button>
          </div>
        </div>
      </section>
      {children}

      <section className={`container ${styles.helpDesk}`}>
        <figure className={styles['helpDesk__figure']}>
          <Image
            src="/img/helpdesk-cover.jpeg"
            width={655}
            height={345}
            alt="Support image"
          />
        </figure>
        <div className={styles['helpDesk__content']}>
          <h2
            className="title"
            dangerouslySetInnerHTML={{ __html: t.raw('helpdesk_cta.title') }}
          />
          <p className="text">{t('helpdesk_cta.text')}</p>
          <Button href="/help-center" color="primary" variant="text" size="fit">
            {t('helpdesk_cta.cta')}
            <Icon name="arrow_forward" style={{ marginLeft: 16 }} />
          </Button>
        </div>
      </section>
    </main>
  );
}
